<script>
  import {mapState, mapActions, mapGetters} from 'vuex'
  export default {
    computed: {
      ...mapGetters({
        links: 'user/wiki/wiki'
      }),
    }
  }
</script>
<template>
  <div class="mag-header-wiki" :class="{'active': links.length}">
    <template v-if="!links.length">
      <i class="mag-icon-nav-top-wiki"></i>
    </template>
    <template v-else>
      <el-dropdown trigger="click">
        <i class="mag-icon-nav-top-wiki"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(link, $index) in links" :key="$index"><a class="mag-header__poper-link" :href="link.IconLink" target="_blank">{{link.PageName}}</a></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </div>
</template>
<style lang="scss">
  .mag-header-wiki{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 40px;
    font-size: 20px;
    cursor: default;
    &.active{
      cursor: pointer;
    }
    a {
      cursor: pointer;
      width: 100%;
      height: 100%;
      text-decoration: none;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
